import angular from 'angular';
import unsubscribeConfirmationTemplate from './unsubscribe.html';

import { unsubscribeUser } from 'report-subscriptions/actions/report-subscriptions-page.actions';

const mapStateToThis = (state) => ({});

const mapDispatchToThis = {
  unsubscribeUser,
};

@Inject('$ngRedux', '$stateParams', '$state', 'Notifications', 'gettextCatalog')
class UnsubscribeConfirmationController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (!this.$stateParams.token) {
      return this.$state.go('home-view');
    }
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onUnsubscribeUser() {
    this.unsubscribeUser(this.$stateParams.token).then(() => {
      this.Notifications.alertSuccess(this.gettextCatalog.getString('Changed successfuly.'));
      return this.$state.go('home-view');
    });
  }
}

class UnsubscribeConfirmation {
  constructor() {
    this.controller = UnsubscribeConfirmationController;
    this.template = unsubscribeConfirmationTemplate;
    return this;
  }
}

export default angular
  .module('unsubscribe-confirmation', [])
  .component('emailUnsubscribe', new UnsubscribeConfirmation())
  .config(['$urlMatcherFactoryProvider',
    function($urlMatcherFactory) {
      $urlMatcherFactory.type('token', {
        decode: function(val) { return val != null ? val.toString() : val; },
        encode: function(val) { return val != null ? val.toString() : val; },
      })
    }])
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider.state('unsubscribe-confirmation', {
        parent: 'arw',
        url: '/unsubscribe/{token:token}',
        template: `<email-unsubscribe></email-unsubscribe>`,
        params: {
          hideMenu: true,
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/components/unsubscribe-confirmation/unsubscribe-component.js